import { HttpInterceptorFn } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { timeout } from 'rxjs/operators';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const defaultTimeout = inject(DEFAULT_TIMEOUT);
  const timeoutValue = req.headers.get('timeout') || defaultTimeout;
  const timeoutValueNumeric = Number(timeoutValue);

  // El header es una instrucción para este interceptor, no para el servidor:
  // se quita antes de salir para no exigirlo en el preflight CORS de hosts externos.
  const outgoingReq = req.headers.has('timeout')
    ? req.clone({ headers: req.headers.delete('timeout') })
    : req;

  return next(outgoingReq).pipe(timeout(timeoutValueNumeric));
};
